/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespRefineMenu_filters$ref = any;
type SbRespRefineMenu_itemSearch$ref = any;
type SbSharedSkyscraperAd_itemSearch$ref = any;
export type SbRespRefineMenuSelector_itemSearch$ref = any;
export type SbRespRefineMenuSelector_itemSearch = {
    readonly filters: ReadonlyArray<{
        readonly " $fragmentRefs": SbRespRefineMenu_filters$ref;
    } | null> | null;
    readonly " $fragmentRefs": SbRespRefineMenu_itemSearch$ref & SbSharedSkyscraperAd_itemSearch$ref;
    readonly " $refType": SbRespRefineMenuSelector_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespRefineMenuSelector_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "filters",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseFilter",
            "plural": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "SbRespRefineMenu_filters",
                    "args": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespRefineMenu_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedSkyscraperAd_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'bcff1f9c493774ef98e38edc26eb899b';
export default node;
